import Typography  from '@mui/material/Typography';
import React from 'react'
import Box from '@mui/system/Box';
import { ROUTES } from '../../../history';
import logo from '../../../assets/logo.png';
import Centered from '../../../components/Centered';
import AppLink from '../../../components/AppLink';

function LandingPage() {
  return (

      <Centered>
        <Box padding={4}>
        <img src={logo} style={{
                height: 200,
                width: 200
            }} alt="logo" /> 

<Typography mb={4}>
        In a world of data protection, we offer great privacy and data retention of all your Electronic Medical Records. We make it available when it is needed by your primary telepresence medical provider. Our idea is to ensure you have the best experience in telepresence medical consultation, and real time access to your primary telepresence medical provider.
      </Typography>
      <Typography mb={4}>
        You have the ability to choose from a geolocated medical provider. This will enable you to develop great relationships with your primary telepresence physician.
      </Typography>
      <Typography mb={4}>
        No more waiting in long lines or in traffic. No more expensive medical bills. Gone are the days when basic healthcare services are for the highly privileged only.
      </Typography>
      <AppLink to={process.env.REACT_APP_BUILD_TARGET === "admin" ? ROUTES.ADMIN_AUTH : ROUTES.CONTRACTOR_AUTH}> Login</AppLink>

<Typography fontWeight="bold" marginTop={10}>
We are not, nor are we holding ourself out to be a doctor/physician, nurse, 
physician's assistant, advanced practice nurse, or any other medical professional 
("Medical Provider"), psychiatrist, psychologist, therapist, counselor, or social 
worker ("Mental Health Provider"), registered dietician or licensed nutritionist, or 
member of the clergy. We are not providing health care, medical or nutritional 
therapy services, or attempting to diagnose, treat, prevent or cure any physical, 
mental or emotional issue, disease or condition. The information provided in or 
through our Mobile Application and Website pertaining to you or your child or any 
other aspect of your life is not intended to be a substitute for the professional 
medical advice, diagnosis or treatment provided by your own Medical Provider or 
Mental Health Provider. You agree and acknowledge that we are not providing 
medical advice, mental health advice, or religious advice in any way. Always seek 
the advice of your own or your child's Medical Provider and/or Mental Health 
Provider regarding any questions or concerns you have about you or your child's 
specific health or any medications, herbs or supplements you or your child are 
currently taking and before implementing any recommendations or suggestions 
from our Mobile Application and Website. Do not disregard medical advice or delay 
seeking medical advice because of information you have read on this Website. Do 
not start or stop taking any medications without speaking to your own or your 
child's Medical Provider or Mental Health Provider. If you or your child have or 
suspect that you have a medical or mental health problem, contact your own or 
your child's Medical Provider or Mental Health Provider promptly. The information 
contained on this Mobile Application and Website has not been evaluated by the 
Food and Drug Administration
</Typography>
        </Box>
      </Centered>
      

  
  )
}

export default LandingPage;